import { render, staticRenderFns } from "./choose-project-list-modal.vue?vue&type=template&id=df1f5386&scoped=true&"
import script from "./choose-project-list-modal.vue?vue&type=script&lang=js&"
export * from "./choose-project-list-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1f5386",
  null
  
)

export default component.exports